import { CreatedInterfaces } from 'interfaces';
import usePatchRequest from './utils/usePatchRequest';

const resource = 'card-holder-patch'

const useUpdateCardHolder = (cardHolderId: string) => {
  const path = `v2/card_holders/${cardHolderId}`;

  const { patchData, patchError, patchLoading, executePatch } = usePatchRequest<CreatedInterfaces<typeof resource>>({
    path,
  });

  return {
    response: patchData,
    isLoading: patchLoading,
    error: patchError,
    updateCardholder: executePatch
  };
};

export default useUpdateCardHolder;
